import { call } from 'redux-saga/effects';
import { initializeSuggestions } from 'store/glue/operation/initializeSuggestions';
import { rejectSuggestion } from 'store/glue/operation/rejectSuggestion';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';

// Rejects the suggestion via the rejectSuggestion operation, then re-fetches
// all suggestions so the new server-side status is reflected in the store.
export function* startRejectSuggestionSaga(
  action: ActionType<typeof improvementsActions.startRejectSuggestion>,
) {
  function* saga() {
    const { suggestionId } = action.payload;

    yield call(rejectSuggestion, { suggestionId });
    yield call(initializeSuggestions);
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
